import { Clear } from '@dreamstack/icons/src/icon-components/Clear'

type Props = {
  handleClose: CallableFunction
}

export const ModalCloseButton = (props: Props) => {
  return (
    <button
      className="absolute top-px-16 right-px-16 md:top-px-32 md:right-px-32 cursor-pointer"
      data-cy="modal_close_button"
      onClick={() => props.handleClose()}
    >
      <Clear className="h-px-32 w-px-32" />
    </button>
  )
}
